import React from 'react';
import { Link } from '@material-ui/core';
import Text from 'components/base/Text';

const TreeTeamsNoSearchResults = ({ removeRootTeamFromFavorites }) => {
  return (
    <Text size='medium' pt='1rem'>
      <Link onClick={() => removeRootTeamFromFavorites({ name: null })}>
        Show all teams (Cancel root)
      </Link>
    </Text>
  );
};

export default TreeTeamsNoSearchResults;
